import { useContext, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { popupMsg } from "../../../../utils/popupMsg";
import { UserManContext } from "../UserManContext";

const EditUserForm = ({ userToUpdate }) => {
  const { t } = useTranslation();

  // Estraiamo anche "sites" dal contesto
  const { roles, sites = [], updateUser } = useContext(UserManContext);

  const [updatedUser, setUpdatedUser] = useState({
    email: userToUpdate.user_email,
    name: userToUpdate.user_name,
    role: userToUpdate.user_role,
    site: userToUpdate.user_site || userToUpdate.site_id || "",
    password: "",
  });

  const { email, password, name, role, site } = updatedUser;

  const onInputChange = (e) => {
    setUpdatedUser({ ...updatedUser, [e.target.name]: e.target.value });
  };

  const edit_user = t("edit") + " " + t("user");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!roles.includes(role)) {
      popupMsg("EditUserForm", t("role") + ": " + t("required_field"), t("Error"));
    } else {
      // Includiamo il parametro "site" nella chiamata ad updateUser
      const results = await updateUser(
        userToUpdate.user_id,
        email,
        password,
        name,
        role,
        site
      );
      if (results && results.success) {
        setUpdatedUser({
          email: "",
          password: "",
          name: "",
          role: t("role") + " *",
          site: "",
        });
        popupMsg("", `${t("User")} '${updatedUser.name}' ${t("updated")}`, edit_user);
      }
    }
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Control
            type="email"
            placeholder={t("email") + " *"}
            name="email"
            value={email}
            onChange={(e) => onInputChange(e)}
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Control
            type="password"
            name="password"
            placeholder={t("password")}
            value={password}
            onChange={(e) => onInputChange(e)}
            autoComplete="on"
          />
        </Form.Group>

        <Form.Group>
          <Form.Control
            type="text"
            placeholder={t("name") + " *"}
            name="name"
            value={name}
            onChange={(e) => onInputChange(e)}
            required
          />
        </Form.Group>

        <Form.Group>
          <Form.Control
            as="select"
            name="role"
            value={role}
            onChange={(e) => onInputChange(e)}
          >
            <option>{t("role") + " *"}</option>
            {roles.map((r) => (
              <option key={r}>{r}</option>
            ))}
          </Form.Control>
        </Form.Group>

        {/* Campo Selezione Sito */}
        <Form.Group>
          <Form.Control
            as="select"
            name="site"
            value={site}
            onChange={(e) => onInputChange(e)}
          >
            <option value="">{t("site") || "Sito"}</option>
            {sites.map((s) => (
              <option key={s.id || s} value={s.id || s}>
                {s.name || s}
              </option>
            ))}
          </Form.Control>
        </Form.Group>

        <Button variant="success" type="submit" block>
          {t("update")} {t("user")}
        </Button>
      </Form>
    </div>
  );
};

export default EditUserForm;